import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationList: {},
  }
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getMonitoringPlotMap({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.get-monitoring-plot-map'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async uploadMaps({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.upload-maps'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
    return null
  },
  async getMonitoringPlotMapPaginate({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.monitoring-plot.get-monitoring-plot-map-paginate'),
      payload
    )
    if (apiResult) {
      return apiResult
    }
  },
  async resetAll({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.monitoring-plot.reset-all'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
